// extracted by mini-css-extract-plugin
export var card = "AboutTeamMemberTemplate-module--card--yBZWh";
export var cardContent = "AboutTeamMemberTemplate-module--card-content--o7oMn";
export var photo = "AboutTeamMemberTemplate-module--photo--szUvk";